import _ from 'lodash';

export function imageLoadedDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: imageLoadedDirectiveCtrl,
	};
}

export class imageLoadedDirectiveCtrl {
	constructor($scope, $element, $attrs, $timeout) {
		'ngInject';
		this.$scope = $scope;
		this.$element = $element;
		this.$attrs = $attrs;
		this.$timeout = $timeout;
	}

	$postLink() {
		this.$timeout(() => {
			if (this.$element[0].tagName.toUpperCase() == 'IMG') {
				this.handleThisImage();
			} else {
				this.handleChildImages();
			}
		});
	}

	evalExpression(locals) {
		this.$timeout(() => {
			this.$scope.$eval(this.$attrs.shImageLoaded, locals);
		});
	}

	handleThisImage() {
		if (this.$element[0].complete) {
			// image already loaded
			const $event = { target: this.$element[0], type: 'complete' };
			this.evalExpression({ $event });
		} else {
			this.$element
				.on('load', $event => this.evalExpression({ $event }))
				.on('error', $event => this.evalExpression({ $event }));
		}
	}

	handleChildImages() {
		const promises = _.map(this.$element.find('img'), img => {
			return new Promise((resolve, reject) => {
				if (img.complete) {
					resolve({ target: img, type: 'complete' });
				} else {
					angular.element(img).on('load', resolve).on('error', resolve);
				}
			});
		});
		Promise.all(promises).then($events => this.evalExpression({ $events }));
	}
}
